import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6bf58856")

_pushScopeId("data-v-6bf58856")
const _hoisted_1 = { class: "waybillDetail" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "deliveryJson" }
const _hoisted_5 = { class: "view-data" }
const _hoisted_6 = { class: "deliveryInfo" }
const _hoisted_7 = { class: "view-data" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")
  const _component_el_collapse = _resolveComponent("el-collapse")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_Table = _resolveComponent("Table")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "close-on-click-modal": false,
    title: "运单详情",
    "destroy-on-close": "",
    modelValue: _ctx.isShow,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShow = $event)),
    width: 886,
    onClose: _ctx.close
  }, {
    default: _withId(() => [
      _withDirectives(_createVNode("div", _hoisted_1, [
        _createVNode("main", null, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", null, "订单编号：" + _toDisplayString(_ctx.props.orderInfo.order_number), 1),
            _createVNode("div", null, "物流主状态: " + _toDisplayString(_ctx.props.orderInfo.delivery_status), 1),
            _createVNode("div", null, "物流单号：" + _toDisplayString(_ctx.props.orderInfo.tracking_number), 1),
            _createVNode("div", null, "物流详细状态: " + _toDisplayString(_ctx.props.orderInfo.delivery_substatus), 1),
            (_ctx.props.orderInfo.pre_time_arrival_at)
              ? (_openBlock(), _createBlock("div", _hoisted_3, " 预计送达时间: " + _toDisplayString(_ctx.props.orderInfo.pre_time_arrival_at), 1))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_el_collapse, null, {
                default: _withId(() => [
                  _createVNode(_component_el_collapse_item, {
                    title: "查看物流原始数据",
                    name: "1"
                  }, {
                    default: _withId(() => [
                      _createVNode("div", null, [
                        _createVNode(_component_el_input, {
                          "model-value": _ctx.jsonStr,
                          size: "small",
                          type: "textarea",
                          resize: "none",
                          rows: "3",
                          readonly: ""
                        }, null, 8, ["model-value"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode("img", {
                class: "icon",
                src: _ctx.copyIcon,
                alt: "",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.copy(_ctx.jsonStr)))
              }, null, 8, ["src"])
            ])
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_el_collapse, {
                modelValue: _ctx.activeNames,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeNames = $event))
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list?.providers, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_collapse_item, {
                      key: index,
                      name: index
                    }, {
                      title: _withId(() => [
                        _createTextVNode(" 物流详情: " + _toDisplayString(item.name), 1)
                      ]),
                      default: _withId(() => [
                        _createVNode(_component_Table, {
                          class: "table",
                          style: {"height":"300px","overflow-y":"scroll"},
                          data: item.tracks
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_table_column, { label: "时间" }, {
                              default: _withId(({ row }) => [
                                _createTextVNode(_toDisplayString(row.timestamp), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "物流信息",
                              width: "600"
                            }, {
                              default: _withId(({ row }) => [
                                _createTextVNode(_toDisplayString(row.description), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1032, ["data"])
                      ]),
                      _: 2
                    }, 1032, ["name"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ])
        ])
      ], 512), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "onClose"]))
})